export default __webpack_public_path__ + "static/media/xoso.c7ee5596.mp3";